var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Gerência",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sigla da Gerência",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.sigla,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "sigla", $$v);
      },
      expression: "form.filters.sigla"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Secretaria Executiva",
      "dense": "",
      "outlined": "",
      "items": _vm.form.lists.listaSecretarias,
      "item-text": "nome",
      "item-value": "codigo",
      "return-object": ""
    },
    model: {
      value: _vm.form.filters.secretariaId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "secretariaId", $$v);
      },
      expression: "form.filters.secretariaId"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('sigfoco-select-ativo', {
    attrs: {
      "cols": 2,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Setor",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.setor,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "setor", $$v);
      },
      expression: "form.filters.setor"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicio", $$v);
      },
      expression: "form.filters.dataInicio"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFim", $$v);
      },
      expression: "form.filters.dataFim"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": _vm.buscarRelatorios
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": _vm.resetForm
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.headersAnalitico,
      "items": _vm.form.lists.listRelatorios,
      "items-per-page": _vm.form.itemsPerPage,
      "footer-props": _vm.$footerProps,
      "sort-by": "dataHoraAcao",
      "sort-desc": true,
      "item-key": "eventoId",
      "show-expand": "",
      "expanded": _vm.expanded
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: `item.nome`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nome) + " ")];
      }
    }, {
      key: `item.sigla`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.sigla) + " ")];
      }
    }, {
      key: `item.secretaria`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.secretaria) + " ")];
      }
    }, {
      key: `item.situacao`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.dataHoraAcao`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarDataHora(item.dataHoraAcao)) + " ")];
      }
    }, {
      key: `item.acao`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(item.acao) + " ")];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref7) {
        var headers = _ref7.headers,
          item = _ref7.item;
        return [_c('td', {
          staticClass: "abas",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.setores, function (setor, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "chip-permissao"
          }, [_c('v-icon', {
            staticClass: "abas",
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-account-multiple")]), _vm._v(" " + _vm._s(setor.nome) + " ")], 1);
        }), 1)], 1)];
      }
    }], null, true)
  }), _vm.form.lists.listRelatorios.length ? _c('sigfoco-buttons', {
    attrs: {
      "actionText": "Baixar PDF",
      "cancelText": "Baixar CSV"
    },
    on: {
      "click": _vm.baixarRelatorioPdf,
      "cancel": _vm.baixarCSVRelatorio
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }